import type { IBasePathAnalyticPageWithChild } from '../types';

import { deepCopy } from '~/utils/deepCopy';
import { create } from 'zustand';

export interface ICachedFunnelChartDataValue {
  firstLocationPath?: string;
  dynamicLevels?: IBasePathAnalyticPageWithChild[];
}
interface IFunnelChartStoreState {
  cachedFunnelChartData: Record<string, ICachedFunnelChartDataValue>;
  setCachedFunnelChartData: (key: string, funnelChartData: ICachedFunnelChartDataValue) => void;
  resetData: () => void;
}

export const useFunnelChartStore = create<IFunnelChartStoreState>()((set, get) => ({
  cachedFunnelChartData: {},
  setCachedFunnelChartData: (key: string, funnelChartData: ICachedFunnelChartDataValue) => {
    const currentFunnelChartData = deepCopy(get().cachedFunnelChartData);
    currentFunnelChartData[key] = {
      ...currentFunnelChartData[key],
      ...funnelChartData,
    };

    set({ cachedFunnelChartData: currentFunnelChartData });
  },
  resetData: () => {
    set({ cachedFunnelChartData: {} });
  },
}));
